import { useEffect, useRef } from 'react';

interface UseIntersectionSentinelParams {
  enabled: boolean;
  onIntersect: () => void;
}

export function useIntersectionSentinel({
  enabled,
  onIntersect,
}: UseIntersectionSentinelParams) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const onIntersectRef = useRef(onIntersect);

  useEffect(() => {
    onIntersectRef.current = onIntersect;
  }, [onIntersect]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const node = sentinelRef.current;
    if (!node) {
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        onIntersectRef.current();
      }
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [enabled]);

  return { sentinelRef };
}
